<template>
  <el-select
    :value="selected"
    @input="dispatch"
    :placeholder="plc || $t(`message.departments`)"
    filterable
    clearable
    multiple="multiple"
  >
    <el-option v-for="item in branches" :key="item.id" :label="item.name" :value="item.id"></el-option>
  </el-select>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import inventory from '@/utils/mixins/components/inventory';

export default {
  mixins: [inventory],
  props: ['branch_id'],
  mounted() {
    if (this.branches && this.branches.length === 0) {
      this.getInventory();
    }
  },
  watch: {
    branch_id:{
       handler: function (val, oldVal) {
          this.selected = val;
          this.$emit("input", this.selected);
       },
       deep: true,
       immediate: true
    },

  },
  computed: {
    ...mapGetters({
      branches: 'branches/inventory',
    }),
 
  },
  methods: {
    ...mapActions({
      getInventory: 'branches/inventory',
    })
  },
};
</script>
